import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { useAppColors } from '../../hooks/useAppColors';
import { useTranslation } from 'react-i18next';

interface ClosedBannerProps {
  isPublicHoliday?: boolean;
  reason?: string | null;
  isToday?: boolean;
}

export function ClosedBanner({ isPublicHoliday, reason, isToday = true }: ClosedBannerProps) {
  const { t } = useTranslation();
  const colors = useAppColors();

  // Determine the message based on whether it's today and if it's a public holiday
  let message: string;
  if (isPublicHoliday) {
    message = isToday ? t('classes.dayClosedPublicHoliday') : t('classes.closedPublicHoliday');
  } else {
    message = isToday ? t('classes.dayClosed') : t('classes.dayClosedOther');
  }

  return (
    <View style={[styles.closedBanner, { backgroundColor: colors.card, borderColor: colors.error }]}>
      <Icon name="calendar-remove" size={18} color={colors.error} />
      <Text style={[styles.closedBannerText, { color: colors.error }]}>
        {message}
        {reason && !isPublicHoliday ? `: ${reason}` : ''}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  closedBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    padding: 12,
    borderRadius: 12,
    borderWidth: 1,
    marginBottom: 12,
  },
  closedBannerText: {
    fontSize: 14,
    fontWeight: '600',
    flex: 1,
  },
});
